import React, { useEffect, useState } from "react";
import Card from "components/card";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import ApiList from "services/apiList";
import FreeSlot from "../components/FreeSlot";
import Select from "components/select";
import Header from "../components/Header";

const ScheduleView = () => {
  const location = useLocation();
  var typeList = [
    {
      id: 3,
      text: "Өрөөгөөр",
    },
    {
      id: 2,
      text: "Багшаар",
    },
  ];
  var dayList = [
    {
      id: 1,
      text: "Даваа",
    },
    {
      id: 2,
      text: "Мягмар",
    },
    {
      id: 3,
      text: "Лхагва",
    },
    {
      id: 4,
      text: "Пүрэв",
    },
    {
      id: 5,
      text: "Баасан",
    },
  ];
  var timeList = [1, 2, 3, 4, 5, 6, 7];
  const [timeDetail, setTimeDetail] = useState([
    "-:-",
    "-:-",
    "-:-",
    "-:-",
    "-:-",
    "-:-",
    "-:-",
  ]);

  const [roomList, setRoomList] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [lessonTypeList, setLessonTypeList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [currentDay, setCurrentDay] = useState(1);
  const [type, setType] = useState(3);
  const mount = useRef(true);
  var user = useSelector(currentUser);

  useEffect(() => {
    const getLessonTypes = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.lessonTeacherTypeUrl).then((json) => {
        if (json["status"]) {
          setLessonTypeList(json["data"]);
        }
      });
    };

    const getTeachers = async () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(
        ApiList.userUrl,"role=teachers"
      ).then((json) => {
        if (json["status"]) {
          const groupedData = json["data"].reduce((result, item) => {
            if (!result[item.teacher_type]) {
              result[item.teacher_type] = [];
            }
            result[item.teacher_type].push(item);
            return result;
          }, {});
          setTeacherList(groupedData);
        }
      });
    };

    const getRooms = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.scheduleClassroomUrl).then(
        (json) => {
          if (json["status"]) {
            const groupedData = json["data"].reduce((result, item) => {
              if (!result[item.building.name]) {
                result[item.building.name] = [];
              }
              result[item.building.name].push(item);
              return result;
            }, {});
            setRoomList(groupedData);
          }
        }
      );
    };

    const getScheduleList = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(
        ApiList.scheduleDetailUrl,
        "schedule=" + location.state.schedule.id
      ).then((json) => {
        if (json["status"]) {
          setScheduleList(json["data"]);
        }
      });
    };

    const fetchData = async () => {
      if (mount.current) {
        mount.current = false;
        await getRooms();
        await getTeachers();
        await getScheduleList();
        await getLessonTypes();
      }
    };

    fetchData();
  }, [location.state.schedule.id, user.school.id, user.token]); // Include all functions used in the effect in the dependency array

  const getFreeSlot = (id) => {
    var freeSlot = [];
    for (let time = 1; time <= timeList.length; time++) {
      const result =
        type === 3
          ? scheduleList.find(
              (item) =>
                item.day === currentDay &&
                item.time === time &&
                item.classroom.id === id
            )
          : scheduleList.find(
              (item) =>
                item.day === currentDay &&
                item.time === time &&
                item.teacher.id === id
            );

      freeSlot.push(
        <FreeSlot
          key={"fslot" + time}
          time={time}
          result={result}
          rowId={id}
          type={type}
          setShowModal={() => {}}
          setShowAlertModal={() => {}}
          setCurrentTime={() => {}}
          setCurrentRow={() => {}}
        />
      );
    }
    return freeSlot;
  };

  const getRoomRow = () => {
    var vheader = [];
    for (const building in roomList) {
      vheader.push(
        <tr key={"r" + building}>
          <th key={"room" + building} rowSpan={roomList[building].length + 1}>
            {building}
          </th>
        </tr>
      );
      roomList[building].forEach((item) => {
        var mainCourseList = [];
        mainCourseList = item.main_course.map((row, index) => {
          return (
            <span className="mr-2 text-btn-1" key={"g" + index}>
              {row.number}
              {row.group}
            </span>
          );
        });
        vheader.push(
          <tr key={"row" + item.id}>
            <th key={"name" + item.id}>
              {item.number} ({item.name})
              <br />
              {mainCourseList}
            </th>

            {getFreeSlot(item.id)}
          </tr>
        );
      });
    }
    return vheader;
  };

  const getTeacherRow = () => {
    var vheader = [];
    for (const teacherType in teacherList) {
      const lt = lessonTypeList.find(
        (item) => item.id === parseInt(teacherType)
      );
      vheader.push(
        <tr key={"r" + teacherType}>
          <th
            key={"teacher" + teacherType}
            rowSpan={teacherList[teacherType].length + 1}
          >
            {lt === undefined || lt === null ? " - " : lt.name}
          </th>
        </tr>
      );
      teacherList[teacherType].forEach((item) => {
        vheader.push(
          <tr key={"row" + item.id}>
            <th key={"name" + item.id}>
              {item.lastname + " " + item.firstname}
            </th>
            {getFreeSlot(item.id)}
          </tr>
        );
      });
    }
    return vheader;
  };

  const getCurrentDayText = () => {
    var selectedDay = dayList[currentDay - 1];
    if (selectedDay === undefined || selectedDay === null) {
      return "";
    }
    return selectedDay.text ?? " ";
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-screen overflow-x-auto pt-0"}>
      <div className="flex items-center ">
        <div className="mt-4 mr-10 w-1/5">
          <Select
            id="types"
            value={type}
            required={true}
            label="Төрөл сонгох"
            defaultIsHidden={true}
            defaultText="Төрөл сонгоно уу."
            onChange={(selected) => {
              setType(parseInt(selected.target.value));
            }}
            children={typeList.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.text}
                </option>
              );
            })}
          />
        </div>
        <div className="mt-4 mr-10 w-1/5">
          <Select
            id="weekday"
            value={currentDay}
            required={true}
            label="Гараг сонгох"
            defaultIsHidden={true}
            defaultText="Гараг сонгоно уу."
            onChange={(selected) => {
              setCurrentDay(parseInt(selected.target.value));
            }}
            children={dayList.map((row, index) => {
              return (
                <option key={index} value={row.id}>
                  {row.text}
                </option>
              );
            })}
          />
        </div>
        <div className="mr-2 h-4 w-4 bg-orange-200"></div>
        <p>Стандарт цаг</p>
        <div className="ml-8 mr-2 h-4 w-4 bg-navy-200"></div>
        <p>Илүү цаг</p>
      </div>
      <table className="custom_table w-full table-auto " key={"table-schedule"}>
        <thead>
          <tr key={"table-header1"}>
            <th rowSpan="2" className="th1">
              <b>{type === 3 ? "Хичээлийн байр" : "Заах аргын нэгдэл"}</b>
            </th>
            <th rowSpan="2" className="th2">
              <b>{type === 3 ? "Анги танхим" : "Багш"}</b>
            </th>
            <th colSpan="7">
              <b>{getCurrentDayText()}</b>
            </th>
          </tr>
          <Header
            timeDetail={timeDetail}
            setTimeDetail={setTimeDetail}
            timeList={timeList}
            start={location.state.schedule.shift.start}
          />
        </thead>
        <tbody>{type === 3 ? getRoomRow() : getTeacherRow()}</tbody>
      </table>
    </Card>
  );
};

export default ScheduleView;
